export { default as browserImg } from './browser.png'
export { default as diplomaImg } from './diploma.png'
export { default as cu } from './cu.png'
export { default as hr } from './hr.png'
export { default as hrCert } from './hrCert.png'
export { default as unc } from './unc.png'
export { default as mt } from './mt.png'
export { default as rl } from './rl.png'
export { default as tl } from './tl.png'
export { default as awsccpCert } from './awsccpCert.png'
export { default as aws } from '../tech/aws.png'
export { default as shop } from './shop.png'
export { default as school } from './school.png'
export { default as hps } from './hps.jpeg'
export { default as keystone } from './keystone.jpeg'
export { default as KeystoneLodgeSpa } from './KeystoneLodgeSpa.jpeg'
export { default as securonix } from './securonix.png'
export { default as ringcentral } from './ringcentral.png'



// WEBPACK FOOTER //
// ./src/layouts/images/resume/index.js